/**
 * Autoplay default interval in ms.
 */
export const AUTOPLAY_DEFAULT_INTERVAL = 5000;

/**
 * Full width size in percent.
 */
export const FULL_WIDTH_PERCENT = 100;

/**
 * Edge from the active index.
 */
export const EDGE_FROM_ACTIVE_INDEX = 2;

/**
 * Max number of pagination items.
 */
export const PAGINATION_ITEMS_MAX = 5;

/**
 * Size of a pagination item. Used to translate wrapper.
 */
export const PAGINATION_ITEM_SIZE = 12;
